import { render } from "./GuiTariffSelect.vue?vue&type=template&id=5cbe1d59"
import script from "./GuiTariffSelect.vue?vue&type=script&lang=js"
export * from "./GuiTariffSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__